/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Base class for properties
 * @external BaseProperty
 * @public
 */

/**
 * The Workspace object encapsulates a PropertyTree to proxy function calls.
 * A Workspace can be seen as a view to the state of the data at a point in time.
 * It is the main interface for adding/removing/modifying high frequency data.
 * @external Workspace
 * @public
 */

/* eslint-disable max-len*/
/**
 * The plain serialization data structure used to encode a ChangeSet.
 * @external SerializedChangeSet
 * @public
 */
/* eslint-enable max-len*/
